import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMemberRevenueStats } from "../Admin/adminAction";
import moment from "moment";
import RevenueCard from "./components/RevenueCard";
import TotalRevenueChart from "./components/TotalRevenueChart";
import MonthlyEntityCountChart from "./components/MonthlyEntityCountChart";
import { fetchOrgSubsCount } from "../Owner/ownerAction";

const Finances1 = () => {
  const dispatch = useDispatch();

  const activeEntity = useSelector((state) => state.adminReducer.activeEntity);
  const pages = useSelector((state) => state?.appReducer?.pages);
  const [components, setComponents] = useState([]);

  useEffect(() => {
    if (activeEntity?._id) {
      const start_date = moment().startOf("year").toISOString();
      const end_date = moment().endOf("year").toISOString();
      dispatch(
        fetchMemberRevenueStats(start_date, end_date, activeEntity?._id)
      );
    }
  }, [activeEntity]);

const financesComponent = useMemo(() => {
  return pages?.find((page) => page?.label === "finances");
}, [pages]);

useEffect(() => {
  if (financesComponent) {
    setComponents(financesComponent);
  }
}, [financesComponent]);


  console.log("components", components);
  return <div>{components?.showTotalIncome && <TotalRevenueChart />}
  {components?.showMonthlyRecords && <MonthlyEntityCountChart /> }
  </div>;
};

export default Finances1;
